import React, { useEffect, useState } from "react";
import SearchIcon from "../../Common/svg/searchicon.jsx";

const SearchInput = ({
  filters,
  handleChange,
  placeholder = "ابحث باسم المستخدم أو البريد الإلكتروني أو رقم الهاتف...",
  delay = 500, // debounce time (ms)
}) => {
  const [value, setValue] = useState(filters.search);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleChange("search", value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return (
    <div className="search">
      <SearchIcon />
      <input
        type="search"
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
